import { useEffect, useState } from "react";

import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import CategoryHead from "@/components/Category/CategoryHead";
// import CourseFilterOneToggle from "@/components/Category/Filter/CourseFilterOneToggle";
import EbooksPage from "@/components/eBooks/EbooksPage";
import Pagination from "@/components/Common/Pagination";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
// import CourseDetails from "../../data/eBooks.json";
import BackToTop from "../backToTop";
import CPStaticContent from '../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";

const CourseFileTwoLayout = (post) => {
  const [courses, setCourse] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  let getAllCourse = post.list
  // JSON.parse(JSON.stringify(CourseDetails.courseDetails));

  const startIndex = (page - 1) * 6;

  const getSelectedCourse = courses.slice(startIndex, startIndex + 6);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setCourse(getAllCourse);
    setTotalPages(Math.ceil(getAllCourse.length / 6));
  }, [setTotalPages, setCourse]);

  return (
    <>
      <PageHead title="eBooks & White Papers" description="eBooks & White Papers collected by CloudPedia.AI" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <CategoryHead title="eBooks/White Papers" countLabel="eBooks" desc="eBooks & White Papers collected by CloudPedia.AI" category={getAllCourse} />
          <div className="rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="inner">
              <div className="container">
                <EbooksPage course={getSelectedCourse} />

                {getAllCourse.length > 6 ? (
                  <div className="row">
                    <div className="col-lg-12 mt--60">
                      <Pagination
                        totalPages={totalPages}
                        pageNumber={page}
                        handleClick={handleClick}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <GoogleAdLarge />
              </div>
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default CourseFileTwoLayout;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("ebooks")
  await stContent.fetchContent()
  return await stContent.getListProps()
} 